import React from 'react';
import { MapBuilderProps } from '../../../MapBuilder';
import { EditorCanvas } from './EditorCanvas';
import { EditorLayout } from './EditorLayout/EditorLayout';
import { PanelLayoutProvider } from './EditorLayout/EditorLayoutContext';
import { useGlobalEditorShortcuts } from './shortcuts/hooks/useGlobalEditorShortcuts';
import { useShapeSelectionShortcuts } from './shortcuts/hooks/useShapeSelectionShortcuts';
import { EditorToolbars } from './toolbars/EditorToolbars';
import { TopToolbar } from './toolbars/TopToolbar';

export interface MapEditorProps extends Pick<MapBuilderProps, 'onSave'> {}

export const MapEditor: React.FC<MapEditorProps> = ({ onSave }) => {
  useGlobalEditorShortcuts();
  useShapeSelectionShortcuts();

  return (
    <PanelLayoutProvider>
      <EditorLayout>
        <div className={'flex flex-col w-full h-full border-r'}>
          <div className={'flex h-[52px] w-full relative'}>
            <TopToolbar />
          </div>
          <div className={'flex h-full w-full relative'}>
            <EditorCanvas />
          </div>
        </div>
      </EditorLayout>
      <EditorToolbars />
    </PanelLayoutProvider>
  );
};
